import React from 'react';
import { Virtuoso, VirtuosoGrid } from 'react-virtuoso';
import { View, Platform } from 'react-native';

interface VirtualizedListProps {
  data: any[];
  itemContent: (index: number) => React.ReactNode;
  horizontal?: boolean;
  columns?: number;
  containerWidth?: number;
  components?: any;
  style?: any;
  totalCount?: number;
  computeItemKey?: (index: number) => string;
}

export const VirtualizedList: React.FC<VirtualizedListProps> = ({
  data,
  itemContent,
  horizontal = false,
  columns = 1,
  containerWidth = 0,
  components,
  style,
  totalCount,
  computeItemKey
}) => {
  console.log('VirtualizedList.web props:', { horizontal, columns, containerWidth, dataLength: data.length });

  if (horizontal) {
    return (
      <Virtuoso
        style={style}
        data={data}
        horizontalDirection
        itemContent={itemContent}
        components={components}
      />
    );
  }

  return (
    <VirtuosoGrid
      style={style}
      data={data}
      itemContent={itemContent}
      totalCount={totalCount || data.length}
      computeItemKey={computeItemKey}
      components={{
        ...components,
        List: React.forwardRef<any, any>((props, ref) => (
          <div
            {...props}
            ref={ref}
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${Math.max(1, columns)}, minmax(400px, 1fr))`,
              gap: '10px',
              padding: '15px',
            }}
          />
        )),
        Item: ({ children, ...props }) => {
          const { className, ref, 'data-index': dataIndex, context, ...viewProps } = props;
          return (
            <View {...viewProps} style={{ minWidth: 400 }}>
              {children}
            </View>
          );
        },
      }}
    />
  );
};

export default VirtualizedList;
